import React, { useState } from "react"
import {
  Button,
  Col,
  Flex,
  Form,
  FormInstance,
  Input,
  Row,
  Tag,
  Typography,
} from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"

import { Currency } from "@src/app/CurrenciesCollection"
import { SelectCurrencyModal } from "@src/shared/componemts/SelectCurrencyModal/SelectCurrencyModal"
type Props = {
  currencies: Currency[]
  form: FormInstance
  label: string
  name: string
  renderSelected: (
    list: string[],
    { remove }: { remove: (id: string) => void },
  ) => React.ReactNode
}
export const WidgetCurrencySelect = ({
  currencies,
  form,
  label,
  name,
  renderSelected,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const selected = (Form.useWatch(name, form) ?? []) as string[]

  const removeTag = (tag: string) => {
    form.setFieldsValue({
      [name]: selected.filter((c: string) => c !== tag),
    })
  }

  const onEnabledCryptoUpdate = (v: string[]) => {
    form.setFieldsValue({ [name]: v })
  }

  return (
    <>
      <Form.Item>
        <Row align="middle" gutter={[32, 32]}>
          <Col span={24}>
            <Flex
              align="center"
              gap={32}
              justify="space-between"
              style={{ width: "100%" }}
            >
              <Typography.Text>{label}</Typography.Text>

              <Button
                onClick={() => setIsOpen(true)}
                size={"small"}
                type="primary"
              >
                <PlusCircleOutlined></PlusCircleOutlined>
                Select {label}
              </Button>

              <Form.Item name={name} noStyle>
                <Input type="hidden" />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={24}>
            {selected.length > 0 &&
              renderSelected(selected, { remove: removeTag })}
          </Col>
        </Row>
      </Form.Item>

      <SelectCurrencyModal
        currencies={currencies}
        initialCheckedList={selected}
        onCancel={() => setIsOpen(false)}
        open={isOpen}
        update={onEnabledCryptoUpdate}
      ></SelectCurrencyModal>
    </>
  )
}
